import React, { Component } from "react";

class ContainerRightG extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slider: [
        {
          id: 1,
          image: "./images/section/gameImageJs.png",
          alt: "JS Memory Game",
          to: "https://memorysaragame.netlify.app/",
          to2: "https://github.com/sarauras1/MemoryGame",
          openm:"open-modal2"
        },
        {
          id: 2,
          image: "./images/section/GameP.png",
          alt: "Python Game",
          to: "https://wordsgamepython.netlify.app/",
          to2: "https://wordsgamepython.netlify.app/",
          openm: "open-modal3"
         }
      ],
    };
  }
  render() {
    return (
      <div
        className="col-left2 animate-element wow delay5 fadeInUp"
        data-wow-delay="0.5s"
      >
        <div className="flat-space">
          <div className="slider-drop-apps custom-dot dot-t2 dot-s2 number-pages none-nav-default mg-dots-s2">
            <div
              className="flat-carousel-box data-effect clearfix"
              data-gap="0"
              data-column="1"
              data-column2="1"
              data-column3="1"
              data-column4="1"
              data-column5="1"
              data-dots="true"
              data-auto="false"
              data-nav="false"
              data-loop="true"
            >
              <div className="owl-carousel">
                {this.state.slider.map((data) => (
                  <div className="featured-post" key={data.id}>
                    <img src={data.image} alt={data.alt} />
                    <div className="buttons-flat">
                      <a className="flat-links" href={data.to}>
                        Go to website
                      </a>
                      <a className="flat-links" href={data.to2}>
                        View Code
                      </a>
                      <a href="#Modal" className={`flat-links ${data.openm}`}>
                        Description
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContainerRightG;
